//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";


function emailLogs() {
    const { handleResponse, handleError } = HandleApiResponse();

    async function getAll(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
            };
            let query;
            query = JSON.stringify(values);
            let res = await fetch(
                `${config.host}/cdr-panel/email-logs/get?query=${query}`,
                obj
            );
            return handleResponse(res);
        }
        catch (err) {
            handleError(err)
        }
    }


    async function exportfile(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
            };
            let query;
            query = JSON.stringify(values);
            let res = await fetch(
                `${config.host}/cdr-panel/email-logs/export?query=${query}`,
                obj
            );
            return handleResponse(res);
        }
        catch (err) {
            handleError(err)
        }
    }

    async function filterApi(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
            };
            let query;
            query = JSON.stringify(values);
            let res = await fetch(
                `${config.host}/cdr-panel/email-logs/filter?query=${query}`,
                obj
            );
            return handleResponse(res);
        }
        catch (err) {
            handleError(err)
        }
    }

    async function resendMail(values) {
        try {
            const obj = {
                method: "POST",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
                body: JSON.stringify(values)
            };

            let res = await fetch(
                `${config.host}/cdr-panel/email-logs/resend`,
                obj
            );
            return handleResponse(res);
        }
        catch (err) {
            handleError(err)
        }
    }

    async function search(value) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
            }
            let res = await fetch(
                `${config.host}/cdr-panel/email-logs/search?searchValue=${value}`,
                obj
            );
            return handleResponse(res)
        }
        catch (err) {
            handleError(err)
        }
    }

    async function sendEmail(values) {
        try {
            const obj = {
                method: "POST",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
                body: JSON.stringify(values)
            };

            let res = await fetch(
                `${config.host}/cdr-panel/email-logs/send`,
                obj
            );
            return handleResponse(res);
        }
        catch (err) {
            handleError(err)
        }
    }

    async function getEmails(value) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
            }
            let res = await fetch(
                `${config.host}/cdr-panel/email-logs/get-emails?loyaltyId=${value}`,
                obj
            );
            return handleResponse(res)
        }
        catch (err) {
            handleError(err)
        }
    }

    return {
        getAll,
        filterApi,
        resendMail,
        search,
        sendEmail,
        getEmails,
        exportfile
    }
}

export default emailLogs